import { PRODUCT_GROUP_TYPE } from '@schuettflix/interfaces';
import {
    ProductGroupBalance,
    ProductGroupBalanceProps,
} from '@/shared/components/ProductGroupHeader/components/ProductGroupBalance.tsx';

export type ProductGroupHeaderProps = {
    products: ProductGroupBalanceProps['products'];
    productGroupType: PRODUCT_GROUP_TYPE;
};

export const ProductGroupHeader = ({ products, productGroupType }: ProductGroupHeaderProps) => {
    return (
        <section className="flex flex-row-reverse">
            <ProductGroupBalance products={products} productGroupType={productGroupType} />
        </section>
    );
};
